const irregularSpacesRegex = /[^\S\x20\n]/g

export const removeIrregularWhiteSpace = (text: string): string => {
  return text.replace(irregularSpacesRegex, '')
}
